import React, { useState, useEffect, useContext } from 'react'
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CurrentActivity from '../components/currentActivity';
import Recall from '../components/recall';
import BottomSheet from '../components/bottomSheet';
import BookingDetails from '../components/bookingDetails';
import { StaticValetActivities } from '../utils/shareData';
import config from "../config.json";
import VisibleActivities from '../components/visibleActivities';
import Activities from '../components/activities';
import AdditionalInfo from '../components/additionalInfo';
import { Feedback, FeedbackHandler } from '../components/feedback';
import Payments from '../components/payment';
import { GlobalStateContext } from '../context/globalStateProvider';
import moment from 'moment';
import Helmet from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import ImageViewer from '../components/imageViewer';
import ExitInfo from '../components/exitInfo';

import { io } from 'socket.io-client';
import PaymentInfo from '../components/paymentInfo';
const socket = io(`${config.HOST_NAME}`, { transports: ['websocket', 'polling', 'flashsocket'] })
const androidAppId = 'in.parksmart.user'
const iosAppId = 'id1538546356'

const Main = () => {
  const theme = useTheme();
  const { id } = useParams();
  
  const { position, setInstalledApps, setIsAndroidAppInstalled, setIsIosAppInstalled, setIsSupported, setError } = useContext(GlobalStateContext)
  const [loading, setLoading] = useState(false)
  const [currentActivity, setCurrentActivity] = useState(null)
  const [activities, setActivities] = useState(null)
  const [bookingDetails, setBookingDetails] = useState(null)
  const [activitiesPercentage, setActivitiesPercentage] = useState(null)
  const [visibleActivities, setVisibleActivities] = useState(null)
  const [isDigitalProcess, setIsDigitalProcess] = useState(null)
  const [isPaid, setIsPaid] = useState(false)
  const [isRecalled, setIsRecalled] = useState(false)
  const [paymentAtEnd, setPaymentAtEnd] = useState(false)
  const [isLinkWithVisitor, setIsLinkWithVisitor] = useState(false)
  const [rating, setRating] = useState(0)

  const fetchData = async () => {
    resetStates()
    setLoading(true);
    try {
      const bookingDetailsResponse = await fetch(`${config.HOST_NAME}/website/bookingParkings/${id}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
      const bookingDetailsData = await bookingDetailsResponse.json();

      if (!bookingDetailsData.success && !bookingDetailsData.data) return
      
      const hasMobileNumber = !!bookingDetailsData.data.mobile_number
      const valetRecallWithoutMobile = bookingDetailsData.data.valet_recall_without_mobile === true || bookingDetailsData.data.valet_recall_without_mobile === 1
      const isDigitalProcess = hasMobileNumber || valetRecallWithoutMobile
      const isPaid = bookingDetailsData.data.status === 'SUCCESS' ? true : false
      
      //Payment At End (Collected by operator at the end)
      const paymentAtEnd = bookingDetailsData.data.is_paid === 2 && bookingDetailsData.data.status !== 'SUCCESS' ? true : false
      const isLinkWithVisitor = bookingDetailsData.data.link_with_visitor === 1
      const skipCarParkedActivity = bookingDetailsData.data.skip_car_parked_activity === 1

      const activitiesResponse = await fetch(`${config.HOST_NAME}/website/bookingParkings/${id}/activities`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
      const activitiesData = await activitiesResponse.json();

      if (!activitiesData?.data[0]) return
      const data = activitiesData.data
      const currentlyOngoingActivity = data[data.length - 1]["action"]
      const activitiesStatusObj = Object.fromEntries(
        Object.entries(StaticValetActivities[isDigitalProcess ? "DIGITAL" : "NON-DIGITAL"]).map(([key, value]) => [key, { ...value }])
      )

      if (!hasMobileNumber && valetRecallWithoutMobile && activitiesStatusObj["VEHICLE_RECALL"]) {
        activitiesStatusObj["VEHICLE_RECALL"].subText = "Please be available at the valet booth to collect your vehicle."
      }
      let activitiesPercentage = 0
      let completedActivities = 0
      let updateActivitiesStatusArray = Object.keys(activitiesStatusObj).map((val) => {
        let findActivity = data.find((v) => v.action === val)
        if (!findActivity) return activitiesStatusObj[val]
        if (findActivity.created_on) completedActivities = completedActivities + 1;
        if (currentlyOngoingActivity === "PARKING_AND_IMAGE_CAPTURE" && val === currentlyOngoingActivity) {

          let imageUrl = ""
          if (findActivity['related_data']) {
            const images = findActivity["related_data"]['images']
            if (images) {
              const parkingImage = images.find(img => img.action === "PARKING_AND_IMAGE_CAPTURE");
              if (parkingImage && parkingImage.image_url) imageUrl = parkingImage.image_url
            }
          }

          const updatedVal = { ...activitiesStatusObj[val], timestamp: findActivity?.created_on, currentlyOngoing: val === currentlyOngoingActivity, imageUrl: imageUrl }
          activitiesStatusObj[val] = updatedVal
          return updatedVal

        } else if (currentlyOngoingActivity === "VEHICLE_RECALL" && val === currentlyOngoingActivity) {
          let findRecallActivity = data.find((v) => v.action === "VEHICLE_RECALL")
          const recallTime = findRecallActivity['related_data'] ? findRecallActivity["related_data"]['recall_time'] : 15
          const added15Mins = moment(findRecallActivity.created_on,).add(recallTime, 'minutes')
          const currentTime = moment()
          const remainingSeconds = moment(added15Mins, 'YYYY-MM-DD HH:mm').diff(currentTime, 'seconds')
          const updatedVal = { ...activitiesStatusObj[val], timestamp: findRecallActivity?.created_on, currentlyOngoing: val === currentlyOngoingActivity, recallTime: recallTime, recallTimeInSeconds: recallTime * 60, remainingSeconds: remainingSeconds > 0 ? remainingSeconds : 0 }
          activitiesStatusObj[val] = updatedVal
          return updatedVal
        } else {
          const updatedVal = { ...activitiesStatusObj[val], timestamp: findActivity?.created_on, currentlyOngoing: val === currentlyOngoingActivity }
          activitiesStatusObj[val] = updatedVal
          return updatedVal
        }
      })

      if(currentlyOngoingActivity === "CAR_HANDOVER") {
        updateActivitiesStatusArray = updateActivitiesStatusArray.filter((val) => val.timestamp)
        setIsRecalled(true)
      }

      if (isDigitalProcess && activitiesStatusObj["VEHICLE_RECALL"]?.timestamp !== "") {
        setIsRecalled(true)
        if (activitiesStatusObj["PARKING_AND_IMAGE_CAPTURE"]?.timestamp === "") {
          delete activitiesStatusObj["PARKING_AND_IMAGE_CAPTURE"]
          updateActivitiesStatusArray = updateActivitiesStatusArray.filter((val) => val.name !== "Car Parked")
        }
      }
      if(skipCarParkedActivity) {
        delete activitiesStatusObj["PARKING_AND_IMAGE_CAPTURE"]
        updateActivitiesStatusArray = updateActivitiesStatusArray.filter((val) => val.name !== "Car Parked")
      }
      updateActivitiesStatusArray = updateActivitiesStatusArray.map((val, i) => { return {...val, id: i + 1}})
      const determineVisibleStatuses = () => {
        let startIndex = 0;
        let endIndex = 0;

        const lastDoneIndex = updateActivitiesStatusArray.reduce((acc, status, index) => {
          if (status.timestamp) return index;
          return acc;
        }, -1);

        if (lastDoneIndex !== -1) {
          startIndex = Math.max(0, lastDoneIndex - 1);
          endIndex = Math.min(startIndex + 3, updateActivitiesStatusArray.length);
        } else endIndex = Math.min(3, updateActivitiesStatusArray.length);

        return updateActivitiesStatusArray.slice(startIndex, endIndex);
      };
      activitiesPercentage = (completedActivities / updateActivitiesStatusArray.length) * 100;

      setBookingDetails(bookingDetailsData.data)
      setRating(bookingDetailsData.data.rating)
      setIsPaid(isPaid)
      setPaymentAtEnd(paymentAtEnd)
      setIsDigitalProcess(isDigitalProcess)
      setActivities(updateActivitiesStatusArray)
      setCurrentActivity(activitiesStatusObj[currentlyOngoingActivity])
      setActivitiesPercentage(activitiesPercentage)
      setVisibleActivities(determineVisibleStatuses());
      setIsLinkWithVisitor(isLinkWithVisitor)

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const resetStates = () => {
    setCurrentActivity(null)
    setActivities(null)
    setBookingDetails(null)
    setActivitiesPercentage(null)
    setVisibleActivities(null)
    setIsPaid(false)
    setPaymentAtEnd(false)
    setIsRecalled(false)
  }

  const isAppInstalled = () => {
    if ('getInstalledRelatedApps' in navigator) {
      setIsSupported(true);
      navigator.getInstalledRelatedApps()
        .then((apps) => {
          setInstalledApps(apps);
          const androidInstalled = apps.some((app) => app.platform === 'play' && app.id === androidAppId);
          setIsAndroidAppInstalled(androidInstalled);
          const iosInstalled = apps.some((app) => app.platform === 'itunes' && app.id === iosAppId);
          setIsIosAppInstalled(iosInstalled);
        })
        .catch((err) => {
          setError(err.message);
          console.error('Error checking installed apps:', err);
        });
    } else {
      setError('getInstalledRelatedApps API not supported');
    }
  }

  useEffect(() => {
    isAppInstalled()
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!socket.connected) socket.connect();
    socket.emit("create-room-valet", id);
    socket.on('VALET_NOTIFIER', () => fetchData());

    return () => socket.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Box sx={theme.customStyles.mainContainer}>
      <Helmet>
        <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
      </Helmet>
      {!loading && currentActivity && bookingDetails ?
        <>
          <CurrentActivity bookingDetails={bookingDetails} currentActivity={currentActivity} parkingName={bookingDetails.parking_name} />
          {position &&
            <BottomSheet isOpen={true}>
              <AdditionalInfo bookingDetails={bookingDetails} currentActivity={currentActivity} isDigitalProcess={isDigitalProcess} parkingName={bookingDetails.parking_name} otp={bookingDetails.otp} />
              {!isPaid && paymentAtEnd && <PaymentInfo bookingDetails={bookingDetails} currentActivity={currentActivity} isLinkWithVisitor={isLinkWithVisitor}/>}
              <VisibleActivities draggable currentActivity={currentActivity} visibleActivities={visibleActivities} activitiesPercentage={activitiesPercentage} />
              <Feedback currentActivity={currentActivity} activitiesPercentage={activitiesPercentage} alreadyRated={bookingDetails.rating > 0} rating={rating} setRating={setRating} />
              {!isPaid && isLinkWithVisitor && <ExitInfo/>}
              <BookingDetails bookingDetails={bookingDetails} isPaid={isPaid} isLinkWithVisitor={isLinkWithVisitor} />
            </BottomSheet>
          }
          {(isPaid || paymentAtEnd) && !isRecalled && isDigitalProcess && <Recall currentActivity={currentActivity} bookingDetails={bookingDetails} refresh={() => fetchData()} />}
          {(!isPaid && !paymentAtEnd) && <Payments bookingDetails={bookingDetails} refresh={() => fetchData()} />}
          <FeedbackHandler bookingId={bookingDetails.id} currentActivity={currentActivity} alreadyRated={bookingDetails.rating > 0} refresh={() => fetchData()} rating={rating} />
          <Activities activities={activities} currentActivity={currentActivity} activitiesPercentage={activitiesPercentage} />
          {/* <ImageViewer/> */}
        </>
        :
        loading && !currentActivity && !bookingDetails
          ? <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <CircularProgress size={50} style={{ color: "#18CC69" }} />
          </Box>
          : !loading && !currentActivity && !bookingDetails
            ? <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
              <CircularProgress size={50} style={{ color: "#18CC69" }} />
            </Box>
            : null
      }
      <ToastContainer position="bottom-right" newestOnTop={true} closeOnClick={true} rtl={false} pauseOnFocusLoss draggable={false} theme="colored" icon={false} autoClose={5000} pauseOnHover />
    </Box>
  )
}

export default Main
